/* eslint-disable @typescript-eslint/no-explicit-any */
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { showToast } from "./AlertSlice";
import { ensureValidToken } from "./authRefresh";

const LOG_PREFIX = "[BaseQuery]";

function clearTokensAndRedirect(api: any): void {
  localStorage.removeItem("auth_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("user");
  api.dispatch(
    showToast({
      message: "Session expired. Please login again.",
      error: true,
      visible: true,
    })
  );
  window.location.href = "/login";
}

// Base query: before each request, refresh token if expiry < 15s; then send request.
const baseQueryWithReauth = async (args: any, api: any, extraOptions: any) => {
  const requestUrl = typeof args === "string" ? args : args?.url ?? "unknown";
 
  try {
    await ensureValidToken();
  } catch (e) {
    clearTokensAndRedirect(api);
    return { error: { status: 401, data: "Session expired" } };
  }

  const baseQuery = fetchBaseQuery({
    baseUrl: "/api/v1",
    prepareHeaders: (headers, { endpoint }) => {
      const authToken = localStorage.getItem("auth_token");
      if (authToken) {
        headers.set("Authorization", `Bearer ${authToken}`);
      }
      // Only send refresh token for switch-store route
      if (endpoint === "switchStore") {
        const refreshToken = localStorage.getItem("refresh_token");
        if (refreshToken) {
          headers.set("x-refresh-token", refreshToken);
        }
      }
      return headers;
    },
  });
  const result = await baseQuery(args, api, extraOptions);
 
  if (result?.error?.status === 400 || result?.error?.status === 403) {
    const errorData = result?.error?.data as any;
    api.dispatch(
      showToast({
        message: errorData?.errors?.[0]?.msg || errorData?.message || "Something went wrong",
        error: true,
        visible: true,
      })
    );
  }
  return result;
};
export default baseQueryWithReauth;
